// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBWYsCguZqJoFRAiE4_CkelMKogVoIytjY",
  authDomain: "archerylinklogin.firebaseapp.com",
  projectId: "archerylinklogin",
  storageBucket: "archerylinklogin.firebasestorage.app",
  messagingSenderId: "669104296648",
  appId: "1:669104296648:web:ed5adee50545c6498f8bfd",
  measurementId: "G-MPGCDPH69D"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

// Kényszerített stabil HTTP hálózati kapcsolat a weben
export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
});

export const storage = getStorage(app);
